export const categories = [
  {
    id: 'cat-1',
    slug: 'latest-entrance',
    name: '最新入口',
    description: '最新可用的草榴社区入口地址，持续更新中',
    icon: 'ri-link',
  },
  {
    id: 'cat-2',
    slug: 'access-guide',
    name: '访问指南',
    description: '详细的访问教程与网络配置方法',
    icon: 'ri-guide-line',
  },
  {
    id: 'cat-3',
    slug: 'faq',
    name: '常见问题',
    description: '访问中常见问题解答与故障排除',
    icon: 'ri-question-answer-line',
  },
  {
    id: 'cat-4',
    slug: 'community-news',
    name: '社区动态',
    description: '草榴社区最新资讯与公告',
    icon: 'ri-newspaper-line',
  },
  {
    id: 'cat-5',
    slug: 'mirror-sites',
    name: '镜像站点',
    description: '草榴社区各镜像站点地址汇总',
    icon: 'ri-server-line',
  },
  {
    id: 'cat-6',
    slug: 'security-tips',
    name: '安全贴士',
    description: '安全访问社区的建议与注意事项',
    icon: 'ri-shield-check-line',
  },
];